import React, { useEffect, useRef, useState } from "react";
import FormCreator from "../../components/Forms/FormCreator";
import { keyPositionRequestFormData } from "./data/KeyPositionRequestForm.data";
import Buttons from "../../components/ui/button/Buttons";
import Accordion from "../../components/Accordion/Accordion";
import { useApproveChangeKeyPositionMutation, useLazyGetRepresentationDetailForAprrovalByIdQuery, useLazyGetSignUpDropDownsForCorporateMembersQuery } from "../../app/services/common/commonApi";
import { setFieldParameter, setNewDataHideForDeleteRole, setFieldParameterNew, AfterApprovalsetFieldParameter } from "./data/Utils/setFieldParameter";
import { decryptAESID, encryptAESID} from "../../utils/Encryption";
import { useNavigate, useParams } from "react-router-dom";
import ToastService from "../../services/toastService/ToastService";
import { setAllDropDownField } from "./data/Utils/dropdownUtils";
import moment from "moment";
import { getAuthProps } from "../../lib/authenticationLibrary";

const KeyPositionRequest = () => {
  const formRefs = {
    accountInfo: useRef(),
    positionInfo: useRef(),
  };
  
  let authData = getAuthProps();
  const { id, changeId } = useParams();
  const editID = id ? decryptAESID(id, false) : 0
  const changeKeyPositionId = changeId ? decryptAESID(changeId, false) : 0
  const [formData, setFormData] = useState(keyPositionRequestFormData);
  const [approveLoading, setApproveLoading] = useState(false);
  const [rejectLoading, setRejectLoading] = useState(false);
  
  const [GetRepresentationDetail, { data: getRepresentationDetailData, isLoading: getRepresentationDetailLoading, isFetching: getRepresentationDetailFetching }] = useLazyGetRepresentationDetailForAprrovalByIdQuery();
  const [signUpDropDownsForCorporateMembers, { data: corporateMemberDropDownsData, isLoading: corporateDropDownsLoading, isFetching: signUpDropDownsFetching }] = useLazyGetSignUpDropDownsForCorporateMembersQuery();
  const [approveChangeKeyPosition, { data: changeKeyPositionData, isLoading: isChangeKeyPosition, isFetching: changeKeyPositionFetching }] = useApproveChangeKeyPositionMutation();
  const handleBack = () => window.history.back();
  const navigate = useNavigate();

  useEffect(() => {
    signUpDropDownsForCorporateMembers();
    if (editID > 0) {
      GetRepresentationDetail(editID)
    }
  }, [editID])

  useEffect(() => {
    if (!isChangeKeyPosition && changeKeyPositionData) {
      if (changeKeyPositionData?.isApproved) {
        ToastService.success("Key Position Change Approved Successfully.");
      }
      else {
        ToastService.error("Key Position Change Rejected Successfully.");
      }
      setTimeout(() => { }, 3000);
      const navigateto = getRepresentationDetailData?.corporateRoleId == "5" ? "/ViewChangeKeyPositionCertificateCoordinator" : "/viewChangeKeyPosition"
      navigate(navigateto);
    }
  }, [isChangeKeyPosition, changeKeyPositionData]);

  const handleReject = async () => {
    setRejectLoading(true);

    try {
      const data = {
        accountInfo: formRefs?.accountInfo?.current?.getFormData(),
        positionInfo: formRefs?.positionInfo?.current?.getFormData(),
      };
      const request = {
        KeyChangeRequestId: editID,
        SGBCCorporateMemberId: getRepresentationDetailData?.sgbcCorporateMemberId,
        SGBCCorporateRepresentativeId: getRepresentationDetailData?.keyChangeRequestId,
        IsApproved: false,
        ApprovalDate: data?.positionInfo?.approvalDate,
        MembershipType: getRepresentationDetailData?.membershipTypeName,
        CorporateRoleId: getRepresentationDetailData?.corporateRoleId,
        NewSalutationId: data?.positionInfo?.newSalutationId,
        NewFirstName: data?.positionInfo?.newFirstName,
        NewLastName: data?.positionInfo?.newLastName,
        NewDesignation: data?.positionInfo?.newDesignation,
        NewEmail: data?.positionInfo?.newEmail,
        NewJobLevelId: data?.positionInfo?.newJobLevel,
        NewJobFunctionId: data?.positionInfo?.newJobFunction,
        NewMobileNumberCountryId: data?.positionInfo?.newMobileNumberCountryId,
        NewMobileNumber: data?.positionInfo?.currentMobile,
        NewContactNumberCountryId: data?.positionInfo?.newContactNumberCountryId,
        NewContactNumber: data?.positionInfo?.newTelephone,
        IsSameEmail: false,
        ApprovalBy: data?.positionInfo?.approvalBy,
        ChangeKeyPositionId: changeKeyPositionId,
      }

      await approveChangeKeyPosition(request).unwrap();

    } finally {
      setRejectLoading(false);
    }

  };

  const handleApprove = async () => {
    setApproveLoading(true);

    try {
      const data = {
        accountInfo: formRefs.accountInfo.current?.getFormData(),
        positionInfo: formRefs.positionInfo.current?.getFormData(),

      };
      // approve request 
      const request = {
        KeyChangeRequestId: editID,
        SGBCCorporateMemberId: getRepresentationDetailData?.sgbcCorporateMemberId,
        SGBCCorporateRepresentativeId: getRepresentationDetailData?.keyChangeRequestId,
        IsApproved: true,
        ApprovalDate: data?.positionInfo?.approvalDate,
        MembershipType: getRepresentationDetailData?.membershipTypeName,
        CorporateRoleId: getRepresentationDetailData?.corporateRoleId,
        NewSalutationId: data?.positionInfo?.newSalutationId,
        NewFirstName: data?.positionInfo?.newFirstName,
        NewLastName: data?.positionInfo?.newLastName,
        NewDesignation: data?.positionInfo?.newDesignation,
        NewEmail: data?.positionInfo?.newEmail,
        NewJobLevelId: data?.positionInfo?.newJobLevel,
        NewJobFunctionId: data?.positionInfo?.newJobFunction,
        NewMobileNumberCountryId: data?.positionInfo?.newMobileNumberCountryId,
        NewMobileNumber: data?.positionInfo?.newMobile,
        NewContactNumberCountryId: data?.positionInfo?.newContactNumberCountryId,
        NewContactNumber: data?.positionInfo?.newTelephone,
        IsSameEmail: data?.positionInfo?.currentEmail == data?.positionInfo?.newEmail ? true : false,
        ApprovalBy: data?.positionInfo?.approvalBy,
        ChangeKeyPositionId: changeKeyPositionId,
      }
      await approveChangeKeyPosition(request);

    } finally {
      setApproveLoading(false);
    }
  };

  useEffect(() => {
    if (!corporateDropDownsLoading && corporateMemberDropDownsData) {
      setAllDropDownField(corporateMemberDropDownsData);
    }
  }, [corporateDropDownsLoading, corporateMemberDropDownsData]);

  useEffect(() => {
    if (!getRepresentationDetailLoading && getRepresentationDetailData) {
      let form = { ...keyPositionRequestFormData }
      if (getRepresentationDetailData?.typeName === "Delete Key Position Information") {
        form = setNewDataHideForDeleteRole(form, authData);
        form = setFieldParameterNew(getRepresentationDetailData, form, authData);
      } else {
        if (getRepresentationDetailData?.changeKeyStatusId == 16 && getRepresentationDetailData?.corporateRoleId) {
          form = AfterApprovalsetFieldParameter(getRepresentationDetailData, form, authData);
        }
        else {
          form = setFieldParameter(getRepresentationDetailData, form, authData);
        }
      }
      setFormData(form);
    }
  }, [getRepresentationDetailLoading, getRepresentationDetailData]);

  const handleViewClick = (data) => {
    navigate(`/viewCorporateMember/${encryptAESID(getRepresentationDetailData?.sgbcCorporateMemberId)}`);
  }


  return (
    <div className="key-position-request container-fluid">

      {corporateMemberDropDownsData && <div className="normal-card p-4 bg-white rounded">
        <Accordion
          title="Account Information"
          className="mb-4"
          button={true}
          buttonLabel="View Corporate Information"
          accordion={false}
          clickEvent = {handleViewClick}
        >
          <div className="row">
            <FormCreator ref={formRefs.accountInfo}
              {...formData.accountInfo}
            />
          </div>
        </Accordion>
        <Accordion
          title={getRepresentationDetailData?.typeName}
          // title="Change Key Position Information"
          className="mb-4"
          button={false}
          accordion={false}
        >
          {getRepresentationDetailData && <div className="row">
            <FormCreator
              ref={formRefs.positionInfo}
              {...formData.positionInfo}
            />
          </div>}
        </Accordion>

        <div className="d-flex justify-content-between mt-4">
          <Buttons
            buttonText="Back"
            buttonTypeClassName="black-btn"
            onClick={handleBack}
          />
          {getRepresentationDetailData?.changeKeyStatusId == 18 && <div className="d-flex gap-3">
            <Buttons
              buttonText="Reject"
              buttonTypeClassName="danger-btn"
              onClick={handleReject}
              isLoading={rejectLoading}
              isDisable={isChangeKeyPosition}
            />
            <Buttons
              buttonText="Approve"
              buttonTypeClassName="success-btn"
              onClick={handleApprove}
              isLoading={approveLoading}
              isDisable={isChangeKeyPosition}
            />
          </div>
          }
        </div>
      </div>}
    </div>
  );
};

export default KeyPositionRequest;
